import React from 'react';
import { ReactTable, VStack, Text } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { Coverage } from '../../../../../../../types/AdvisoryReport';
import useInsuranceModalCoverageTable from '../../../../../hooks/useInsuranceModalCoverageTable';

interface Props {
  onEdit: (id: string) => void;
  onRemove: (id: string) => void;
  data: Coverage[];
  coverageToEdit?: string;
}

const AddInsuranceModalCoverageTable: React.FC<Props> = ({
  onRemove,
  onEdit,
  data,
  coverageToEdit,
}) => {
  const { t } = useTranslation();
  const { columns } = useInsuranceModalCoverageTable({
    onEdit,
    onRemove,
    coverageToEdit,
  });

  return (
    <VStack align="stretch" spacing="3">
      <Text color="gray.500" textStyle="smallBodyMedium">
        {t('ADVISORY-REPORTS_CURRENT-INSURANCE_MODAL_DETAIL_COVERAGES')}
      </Text>
      <ReactTable
        data={data}
        columns={columns}
        emptyText={
          <Text textStyle="smallBody" color="gray.500" align="center">
            {t(
              'ADVISORY-REPORTS_CURRENT-INSURANCE_MODAL_DETAIL_EMPTY-COVERAGES',
            )}
          </Text>
        }
      />
    </VStack>
  );
};

export default AddInsuranceModalCoverageTable;
